<template>
  <div class="box">
    <p class="p1">支持搜索以下内容</p>
    <ul>
      <li v-for="item in list" @click="jump(item)">
        <img :src="item.img" alt="" />
        <span>{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      list: [
        {
          name: '头条',
          img:
            'http://cdn.yxvzb.com/newWechat/image/%E9%A6%96%E9%A1%B5-%E5%A4%B4%E6%9D%A1@2x.png',
          path: 'headlineList'
        },
        {
          name: '课程',
          img:
            'http://cdn.yxvzb.com/newWechat/image/%E9%A6%96%E9%A1%B5-%E8%AF%BE%E7%A8%8B@2x.png',
          path: 'courseList'
        },
        {
          name: '专区',
          img:
            'http://cdn.yxvzb.com/newWechat/image/%E9%A6%96%E9%A1%B5-%E4%B8%93%E5%8C%BA@2x.png',
          path: 'zoneList'
        }
      ]
    };
  },
  methods: {
    jump(item) {
      this.$router.push({ name: item.path });
    }
  },
  computed: {},
  components: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.box {
  margin-top: 0.53rem;
  ul {
    width: 80%;
    margin: auto;
    margin-top: 0.53rem;
    display: flex;
    justify-content: space-around;
    img {
      width: 1.066rem;
      display: block;
    }
    span {
      display: block;
      text-align: center;
      margin-top: 0.1rem;
      font-size: 0.266rem;
    }
  }
}
.p1 {
  font-size: 0.32rem;
  color: #999;
  text-align: center;
}
</style>
